import { ColumnData } from 'ui/tableHeader';

export enum Frequency {
  DISABLED = 'Disable',
  EVERY = 'OnEverySMS',
  FIRST = 'OnFirstSMS',
}

export type LastModified = {
  timestamp: string;
  timezone: string;
};

export enum FieldId {
  COUNTRY = 'regionName',
  ALPHANUMERIC = 'alphanumeric',
  NUMERIC = 'numeric',
  FREQUENCY = 'frequency',
  UPDATED_AT = 'updatedAt',
  ACTIONS = 'actions',
}

export type SortableFields = FieldId.COUNTRY | FieldId.UPDATED_AT;

export type Field = {
  fieldName: string | JSX.Element;
  fieldId: FieldId;
  sortable: boolean;
  tooltipContent?: string;
};

export type Column = ColumnData & { RowCell: (row: any) => JSX.Element };

export type Row = {
  id: string;
  regionName: JSX.Element;
  alphanumeric: JSX.Element;
  numeric: JSX.Element;
  frequency: JSX.Element;
  updatedAt: JSX.Element;
  actions: JSX.Element;
};

export enum OptOutType {
  ALPHANUMERIC = 'alphanumeric',
  NUMERIC = 'numeric',
}

export type EditablePreferenceFields = {
  alphanumericOptOut: string;
  numericOptOut: string;
  frequency: Frequency;
};
